import type Lenis from 'lenis';

// Module-local singleton — the live Lenis instance created by `useScrollProgress`
// is set here on mount and cleared on unmount. Consumers (the camera rig hijack)
// read it to drive `lenis.scrollTo()` instead of fighting Lenis with raw window
// scroll, which would cause double-scroll glitches.
let _lenis: Lenis | null = null;

export function setLenis(lenis: Lenis | null): void {
  _lenis = lenis;
}

export function getLenis(): Lenis | null {
  return _lenis;
}
